import { render, staticRenderFns } from "./WebhookList.vue?vue&type=template&id=5c184b1a&"
import script from "./WebhookList.vue?vue&type=script&lang=js&"
export * from "./WebhookList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports